import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { useCallback } from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var styles = {
    button: {
        display: "inline-block",
        margin: "0",
        padding: "0.75rem 1rem",
        border: "0",
        borderRadius: "0.317rem",
        backgroundColor: "#0077b5",
        color: "#fff",
        textDecoration: "none",
        fontWeight: "700",
        fontSize: "1rem",
        lineHeight: "1.5",
        fontFamily: "inherit",
        cursor: "pointer",
        WebkitAppearance: "none",
        WebkitFontSmoothing: "antialiased",
        position: "relative",
        top: "-0.1em",
        verticalAlign: "middle",
        marginRight: "0.317rem",
        ":hover": {
            opacity: 0.5
        },
        "&:active": {
            boxShadow: "inset 0 3px 4px hsla(0, 0%, 0%, 0.2)"
        },
        "&:focus": {
            outline: "5px auto -webkit-focus-ring-color",
            outlineOffset: "-2px"
        },
    },
    icon: {
        fill: "#fff",
        marginRight: "10px"
    }
};

var LinkedInIcon = function () { return (jsx("svg", __assign({ style: styles.icon, xmlns: "http://www.w3.org/2000/svg", width: "18", height: "18", viewBox: "0 0 24 24" }, { children: jsx("path", { d: "M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" }, void 0) }), void 0)); };

/**
 * Renders a button that can be customized to add a certification to Linkedin
 *
 * @param certificationName - The name of the certificate
   @param organizationName - The name of the organizaion
   @param issuedMonth - Certification issued month
   @param issuedYear - Certification issued year
   @param expirationMonth - Certification expiry month
   @param expirationYear - Certification expiry year
   @param certificateId - Unique ID of the certification
   @param certificateURL - URL for the certification
   @param newTab - If you want to open in a new tab or in the existing tab
   @param customButton - Lets you use your own button
 *
 * @example
 * <LinkedinCertification
     certificationName="My Sample Certification"
     organizationName="My Awesome Organization"
     issuedMonth={12}
     issuedYear={2021}
     expirationMonth={3}
     expirationYear={2023}
     certificateId="29c2e87e-5c1c-11ec-bf63-0242ac130002"
     certificateURL="https://www.google.com"
     newTab={true}
     customButton={<button className="button is-primary">My Custom Button</button>}
    />
 */
var LinkedinCertification = function (props) {
    var generateLink = useCallback(function (certificationName, organizationName, issuedYear, issuedMonth, expirationYear, expirationMonth, certificateURL, certificateId) {
        if (issuedYear !== undefined && expirationYear !== undefined) {
            if (issuedYear > expirationYear) {
                throw new RangeError("Expiration year should be greater than the issued year");
            }
        }
        var urlString = "https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME\n    &name=".concat(encodeURIComponent(certificationName), "&organizationName=").concat(encodeURIComponent(organizationName), "&issueYear=").concat(issuedYear === null || issuedYear === void 0 ? void 0 : issuedYear.toString(), "&issueMonth=").concat(issuedMonth === null || issuedMonth === void 0 ? void 0 : issuedMonth.toString(), "&expirationYear=").concat(expirationYear === null || expirationYear === void 0 ? void 0 : expirationYear.toString(), "&expirationMonth=").concat(expirationMonth === null || expirationMonth === void 0 ? void 0 : expirationMonth.toString());
        if (certificateURL !== undefined) {
            urlString =
                urlString +
                    "&certUrl=".concat(encodeURIComponent(certificateURL));
        }
        if (certificateId !== undefined) {
            urlString = urlString + "&certId=".concat(certificateId);
        }
        return urlString;
    }, Object.keys(props)); //end
    return (jsx(Fragment, { children: jsx("a", __assign({ href: generateLink(props.certificationName, props.organizationName, props.issuedYear, props.issuedMonth, props.expirationYear, props.expirationMonth, props.certificateURL, props.certificateId), target: props.newTab ? "_blank" : "_self" }, { children: props.customButton ? (props.customButton) : (jsxs("button", __assign({ style: styles.button }, { children: [jsx(LinkedInIcon, {}, void 0), "Add to LinkedIn"] }), void 0)) }), void 0) }, void 0));
};

export { LinkedinCertification };
